import { CallOutDetailContext, CategoryTabInfo, OBCategoryTab, OBPolicyData } from '@pulseops/outbound'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'
import { useIsFocused } from '@react-navigation/native'
import { ProductTypeC } from '@pulseops/inbound'
import { isNil } from 'lodash'
import { OBPolicyTab } from '../ob-rmd-special-info/OBPolicyTab'
import { OBInvestmentTab } from '../ob-rmd-special-info/ob-investment-tab/OBInvestmentTab'
import { OBOthersTab } from './OBOthersTab'

export const OBRMDBAUSpecialInformation = () => {
  const { t, i18n } = useTranslation()
  const [categoryTabIndex, setCategoryTabIndex] = React.useState(0)
  const [categoryTabList, setCategoryTabList] = React.useState<CategoryTabInfo[]>([])
  const [productInfo, setProductInfo] = React.useState<ProductTypeC>()
  const [dataPolicy, setDataPolicy] = React.useState<OBPolicyData | null>(null)
  const { permissions, policyNumber, clientNumber, caseId } = React.useContext(CallOutDetailContext)
  const isFocused = useIsFocused()

  React.useEffect(() => {
    if (isFocused) {
      setCategoryTabIndex(0)
    } else {
      setProductInfo(undefined)
    }
  }, [isFocused])

  const checkTabViewPermission = () => {
    const listTabPermission: CategoryTabInfo[] = []
    listTabPermission.push({
      label: t('Outbound:OBSpecialInfo:Policy'),
      key: '1'
    })
    if (!isNil(productInfo) && ['ULP', 'ILP'].includes(productInfo?.body.productType as string)) {
      listTabPermission.push({
        label: t('Outbound:OBSpecialInfo:Investment'),
        key: '2'
      })
    }
    listTabPermission.push({
      label: t('Outbound:OBSpecialInfo:OtherTab'),
      key: '3'
    })

    setCategoryTabList(listTabPermission)
  }

  React.useEffect(() => {
    checkTabViewPermission()
  }, [permissions, i18n.language, productInfo])

  const getTabKey = (tabIndex: number) => {
    const tabShow = categoryTabList[tabIndex]
    return tabShow?.key ?? ''
  }

  const getComponentByTabIndex = () => {
    switch (getTabKey(categoryTabIndex)) {
      case '1':
        return <OBPolicyTab setProductInfo={setProductInfo}></OBPolicyTab>
      case '2':
        return <OBInvestmentTab productInfo={productInfo} />
      case '3':
        return <OBOthersTab policyNumber={policyNumber} clientNumber={clientNumber} caseId={caseId} dataPolicy={dataPolicy} setDataPolicy={setDataPolicy}/>
      default:
        return <></>
    }
  }

  return (
    <View style={specialStyles.container}>
      <OBCategoryTab
        dataSource={categoryTabList}
        onChangeTab={(index) => {
          setCategoryTabIndex(index)
          // setTabIndex(categoryTabList[index])
        }}
        activeTabIndex={categoryTabIndex}
      ></OBCategoryTab>
      {isFocused ? getComponentByTabIndex() : <></>}
    </View>
  )
}
const specialStyles = StyleSheet.create({
  container: {
    marginTop: 24
  }
})
